import CategoriaService from './../_services/CategoriaService'
import { erroArrayToString } from '@/utils/trataErroRetornoApi'
import { categoriaModel } from '@/models/categoria'

const state = {
  loading: false,
  loadingStore: false,
  dropDownCategorias: [],
  categorias: [],
  categoriaSelecionada: undefined,
  erros: '',
}

const getters = {
  GET_CATEGORIAS : (state) => state.categorias,
  GET_DROPDOWN: state => state.dropDownCategorias,
  GET_ERROS: state => state.erros,
}

const mutations = {

  SET_LOADING_STORE: (state, ativo) => {
    state.loadingStore = ativo ? ativo : false
  },

  CATEGORIA_SELECTED : (state, { categoria }) => {
    state.categoriaSelecionada = Object.assign({}, categoria)
  },

  SET_CATEGORIAS : (state, { categorias }) => {
    state.categorias = categorias
  },

  SET_DROPDOWN : (state, categorias) => {
    state.dropDownCategorias = categorias
  },

  SET_ERROS : (state, erros) => {
    state.erros = erros.erros
  },

  ERASE_ERROS : (state) => {
    state.erros = ''
  },

  RESET_SELECTED : state => state.categoriaSelecionada = undefined,

}

const actions = {

  LOAD_DROPDOWN : async ({commit}, id) => {
    commit('SET_DROPDOWN', [])
    commit('ERASE_ERROS')
    if (!id) id=0
    await CategoriaService.getDropDown(id)
    .then(response => {
      if (response.data.status) {
        var drop = [{value: '', text:'', tipoprocesso_id: ''}]
        var obj = response.data.categorias
        Object.keys(obj).forEach(function (item) {
          var array = { value: obj[item].id, text: obj[item].descricao, tipoprocesso_id: obj[item].tipoprocesso_id }
          drop.push(array)
        })
        commit('SET_DROPDOWN', drop)

      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }
    })
    .catch(error => {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
      reject(error)
    })
  },

  GET_CATEGORIAS : async ({ commit }) => {
      commit('SET_CATEGORIAS', { categorias : []})
      commit('ERASE_ERROS')
      await CategoriaService.getCategorias()
      .then(response => {
        if (response.data.status) {
          commit('SET_CATEGORIAS', { categorias : response.data.categorias })
        } else if (response.data.erro) {
          commit('SET_ERROS', { erros: response.data.erro })
        }
      })
      .catch(error => {
        console.log(error)
        commit('SET_ERROS', { erros: 'Erro ao acessar api' })
        reject(error)
      })
  },

  GET_CATEGORIA : async ({commit}, id) => {
    commit('ERASE_ERROS')
    await CategoriaService.getCategoria(id)
    .then(response => {
      if (response.data.status) {
        commit('CATEGORIA_SELECTED', { categoria : response.data.categoria })
      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }
    })
    .catch(error => {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
      reject(error)
    })

  },

  STORE_CATEGORIA : async ({ commit, dispatch }, categoria) => {
    commit('ERASE_ERROS')
    try {
      commit('SET_LOADING_STORE', true)
      if (!categoria.id || !(categoria.id > 0)) { 
        var response = await CategoriaService.postCategoria(categoria)
      } else {
        var response = await CategoriaService.putCategoria(categoria.id, categoria)
      }

      if (response.data.status) {
        commit('CATEGORIA_SELECTED', { categoria : response.data.categoria })
        dispatch('GET_CATEGORIAS')
        //await dispatch('GET_CATEGORIA', response.data.categoria.id)

      } else if (!response.data.status && response.data.validacao) {
        var erros = erroArrayToString(response.data.erros)
        commit('SET_ERROS', { erros: erros })
      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }

    } catch (error) {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
      reject(error)
    } finally {
      commit('SET_LOADING_STORE', false)
    }
  },

  DELETE_CATEGORIA : async ({ commit, dispatch }, cliente) => {
    commit('ERASE_ERROS')
    try {
      var response = await CategoriaService.deleteCategoria(cliente.id)

      if (response.data.status) {
        await dispatch('GET_CATEGORIAS')

      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }

    } catch (error) {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
      reject(error)
    }
  },

  CATEGORIA_SELECTED : async ({dispatch, commit}, id) => {
    if (id > 0) { 
      await dispatch('GET_CATEGORIA', id)
    } else {
      var obj = new categoriaModel.categoria()
      await commit('CATEGORIA_SELECTED', { categoria: obj })
    }    
  },

  RESET_SELECTED : ( {commit} ) => { commit('RESET_SELECTED') },

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
} 


// WEBPACK FOOTER //
// ./src/views/Categoria/_store/index.js